import clsx from 'clsx';
import { useStore } from '../store';

export function Toast() {
  const { toast } = useStore();

  return (
    <div
      className={clsx(
        'fixed bottom-6 right-6 z-50 rounded-lg border border-brand-border border-l-4 border-l-brand-orange bg-brand-surface px-5 py-4 text-sm font-medium text-brand-text-primary shadow-xl shadow-black/50 transition-all duration-300 transform',
        toast.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
      )}
    >
      {toast.message}
    </div>
  );
}
